import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-luxon';
import { getFormatedLabels } from './helper/getFormatedLabels';
import { useEffect, useMemo, memo } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  registerables,
  TimeScale,
} from 'chart.js';
import { ChartData } from './types';

ChartJS.register(...registerables, LineElement, CategoryScale, TimeScale, LinearScale, zoomPlugin);

const chartPlugins = [zoomPlugin];

type LineChartProps = {
  chartRef: any;
  options: any;
  allSeries: any;
  extendedColors: string[];
};

const LineChart = memo(({ chartRef, options, allSeries, extendedColors }: LineChartProps) => {
  const formattedLabels = useMemo(() => getFormatedLabels({ data: allSeries }), [allSeries]);

  const datasets = useMemo(
    () =>
      allSeries.map((item: ChartData, index: number) => {
        const yAxisID = index === 0 ? 'y' : `y${index - 1}`;
        const colorIndex = index;

        const color = extendedColors[colorIndex];

        return {
          label: item.name,
          data: item.data.map(([timestamp, value]) => ({
            x: new Date(timestamp),
            y: value,
          })),
          yAxisID,
          backgroundColor: color,
          borderColor: color,
          borderWidth: 2,
          radius: 0,
          pointHoverRadius: 0,
        };
      }),
    [allSeries, extendedColors]
  );
  const userData = useMemo(
    () => ({
      labels: formattedLabels,
      datasets,
    }),
    [formattedLabels, datasets]
  );

  useEffect(() => {
    if (chartRef && chartRef.current) {
      chartRef.current.canvas.style.touchAction = 'unset';
    }
  }, [chartRef]);

  return (
    <Line
      ref={chartRef as React.MutableRefObject<any>}
      data={userData}
      options={options}
      plugins={chartPlugins}
      style={{ maxHeight: '400px', height: '400px' }}
    />
  );
});

export default LineChart;
